import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\USUARIO\\Escritorio\\¨MERCALIA¨\\SITIO WEB\\mercaliaconnect\\src\\components\\RegistroVisita.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "D:\\USUARIO\\Escritorio\\¨MERCALIA¨\\SITIO WEB\\mercaliaconnect\\src\\context\\LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "D:\\USUARIO\\Escritorio\\¨MERCALIA¨\\SITIO WEB\\mercaliaconnect\\src\\styles\\tailwind.css");
